import * as React from 'react';
import moment from 'moment';

import { ISearchContext, ISearchFilter, FilterParameterTypeString } from '../../global/models/search-context';
import { DropdownSelect } from '../../global/components/inputs/selects/dropdown-select';
import { IDropdownOption } from '../../global/state-helpers/filters';
import { ISearchField } from '../models/search-field';
import { SearchFilter } from './search-filter';
import { IEpiProps } from '../models/epi-props';

interface IProps {
    epiProps: IEpiProps;

    searchContexts: ISearchContext[]
    selectedContextIndex: number,
    searchField: ISearchField,
    /** The filters available under the current context */
    searchFilters: ISearchFilter[]

    onContextChange: (index: number) => void;
    onSearchFieldChange: (searchField: ISearchField) => void;
    onKeyDown: (e: any) => void;
}

interface IState {

}

export class SearchContext extends React.Component<IProps, IState> {
    private initialInput: HTMLInputElement;

    render() {
        const { searchField, searchFilters, epiProps } = this.props;
        
        return (
            <div className="advanced-search-context">
                <p>Show results from</p>
                <div className="advanced-search-query">
                    <DropdownSelect
                        name="adv-search-context"
                        values={this.getSearchContextValues()}
                        onDropdownSelect={this.onContextChange} />
                    <SearchFilter
                        name="Initial"
                        epiProps={this.props.epiProps}
                        searchField={this.props.searchField}
                        searchFilters={this.props.searchFilters}
                        onChange={this.props.onSearchFieldChange}
                        onKeyDown={this.props.onKeyDown} />
                </div>
            </div>
        )
    }

    getSearchContextValues = (): IDropdownOption[] => {
        const { selectedContextIndex, searchContexts } = this.props;
        var dropdownOptions = searchContexts.map(
            (searchContext: ISearchContext, index: number): IDropdownOption => ({
                id: index.toString(),
                display: searchContext.display,
                selected: selectedContextIndex == index
            }));
        
        return dropdownOptions;
        
    }

    onContextChange = (id: string): void => {
        this.props.onContextChange(parseInt(id));
    }
}